import StartNewGameComponent from "./StartNewGameComponent";
import MainComponent from "../global/mainlayout/MainComponent";

export default function StartNewGamePage() {
  return(
    <MainComponent title="Neues Spiel starten" >
      <StartNewGameComponent />
    </MainComponent>
  )
}